// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"733fb493","498":"653e90f7","703":"beec32de"}[chunkId] + ".chunk.js";
};